var Marionette = require('marionette'),
    ZoneView = require('./zone');


module.exports = Marionette.CollectionView.extend({

    childView: ZoneView

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/zoneLayer/zoneLayer.js
 ** module id = 442
 ** module chunks = 0
 **/